import { useContext } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import FacetDataContext from '~/contexts/FacetDataContext';
import theme from '~/theme';
import { colorHexValues } from './constants';
import Checkbox from '../Checkbox';
import LabelWithCount from '../LabelWithCount';
import { CommonWrapper } from '../styles';

type OwnProps = {
  filterKey: 'colors' | 'interiorColors';
};

type LabelProps = {
  displayName: string;
  count: number;
};

const Label = ({ count, displayName }: LabelProps) => {
  return (
    <div className="flex items-center justify-between py-2">
      <LabelWithCount count={count} displayName={displayName} />
      {displayName === 'Other' ? (
        <img
          className="h-[24px]"
          src={`${process.env.CVNA_APP_ASSETS_CDN}/serenity-ui/images/other.png`}
          alt="other"
        />
      ) : (
        <div
          className="border border-1 border-solid h-[24px] rounded-full w-[24px]"
          style={{
            background: colorHexValues[displayName],
            borderColor:
              displayName === 'White'
                ? theme.carvana.gray.light
                : colorHexValues[displayName]
          }}
        />
      )}
    </div>
  );
};

const ColorSwatches = ({ filterKey }: OwnProps) => {
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const { facetData } = useContext(FacetDataContext);

  return (
    <CommonWrapper>
      {facetData[filterKey]?.buckets?.map(({ key, count, displayName }) => (
        <Checkbox
          checked={appliedFilters[filterKey]?.includes(key)}
          className="w-full"
          facet={key}
          filter={key}
          id={`${filterKey} - ${displayName}`}
          key={`${filterKey} - ${displayName}`}
          label={
            <Label
              count={count}
              displayName={displayName
                .replace(/(interior|exterior)/i, '')
                .trim()}
            />
          }
          onChange={() => {
            updateListFilter({
              value: key,
              filterKey
            });
          }}
        />
      ))}
    </CommonWrapper>
  );
};

export default ColorSwatches;
